import React, { Component }  from 'react';
import assets from '../../../helpers/Assets';
import './EmptyView.scss';

class EmptyView extends Component {
  static defaultProps = {
  }

  state = {
  }

  componentWillMount = () => {
  }

  componentDidMount = () => {

  }
  render() {
    const {text} = this.props;
    return (<div className='empty_view_container'>
      <img alt='' style={{ width: '2.32rem', height: 'auto' }} src={assets.BOX}></img>
      <div className='empty_view_text'>{text || 'Not Found'}</div>
    </div>);
  }
}

export default EmptyView;

